module.exports = __webpack_public_path__ + "static/media/recipe.1770d682.pdf";